import { Link } from "react-router-dom";
import { GetGiftcardpier } from "../../actions/giftcardpier.jsx";
import { GotoLogin } from "../../actions/renovarLog.jsx";

import style from "../../styles/grid.module.css";
import axios from "axios";
import { formatos } from "../../actions/formats.jsx";
import { Pencil, SquareX, CirclePlus, Gift } from "lucide-react";
import Usuario from "../usuarios/usuario.jsx";

const Abmgiftcardpier = () => {
   const filtroTipo = 1; // productos
   const { formatoNumero } = formatos();
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "giftcardpier/";
   const giftcarddatos = GetGiftcardpier();
   const handleRemove = async (id) => {
      let text =
         "Se va a eliminar la compra selecionada!\nSelecione Aceptar or Cancelar.";
      if (window.confirm(text) === true) {
         const response = await axios.delete(url + id, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         });
         console.log("response: ", response);
         window.location.href = "/giftcardpier";
      }
   };

   const formatDate = (fecha) => {
      var newDate1 = fecha.substring(0, 10).split("-");
      var newdate2 = newDate1[2] + "/" + newDate1[1] + "/" + newDate1[0];
      return newdate2;
   };

   if (giftcarddatos?.message === "Token inválido") {
      return <GotoLogin />;
   }
   console.log("giftcarddatos: ", giftcarddatos);
   return (
      <>
         <div className={style.tableCli}>
            <div>
               <div className={style.gridTitle}>
                  <h2>
                     <Gift />
                     &nbsp;&nbsp;Gift Cards Piercing
                  </h2>
               </div>
            </div>
            <div>
               <div>
                  <Link
                     to={"/formGiftcardpier"}
                     className="dLink"
                     title="Alta Gift Card"
                     state={{
                        id_primary: 0,
                        id: 0,
                        companyId: 0,
                        descripcion: "",
                        total: 0,
                        tipoPago: 1,
                        serv_id: 0,
                        cod_status: 1,
                     }}
                  >
                     <CirclePlus className="lucidePlus" />
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
         </div>
         <div>
            <table style={{ width: "70%" }}>
               <thead>
                  <tr>
                     <th style={{ width: "15%" }}>Fecha</th>
                     <th style={{ width: "50%" }}>Nombre</th>
                     <th style={{ width: "20%" }}>Total</th>
                     <th style={{ width: "15%" }}>Acciones</th>
                  </tr>
               </thead>
               <tbody>
                  {giftcarddatos &&
                     giftcarddatos?.map((insu) => {
                        return (
                           <tr
                              key={insu.id}
                              className={
                                 parseInt(insu.cod_status) === 2
                                    ? style.trdatosRed
                                    : style.trdatos
                              }
                           >
                              <td className={style.style_code}>
                                 {formatDate(insu.fecha)}
                              </td>
                              <td className={style.style_td}>
                                 {insu.nombre} {insu.cliente_nombre && ` / ${insu.cliente_nombre}`  }
                              </td>
                              <td className={style.style_total}>
                                 $ {formatoNumero(insu.total)}
                              </td>
                              <td className={style.aligncenter}>
                                 <Link
                                    to={"/formGiftcardpier"}
                                    className="dLink"
                                    state={{
                                       id_primary: insu.id_primary,
                                       id: insu.id,
                                       companyId: insu.companyId,
                                       nombre: insu.nombre,
                                       total: insu.total,
                                       documento_solicitante:
                                          insu.documento_solicitante,
                                       documento_cliente:
                                          parseInt(insu.documento_cliente) === 0
                                             ? " "
                                             : insu.documento_cliente,
                                       tipoPago: insu.tipoPago,
                                       usuario: insu.userId,
                                       serv_id: insu.serv_id,
                                       cod_status: insu.cod_status,
                                    }}
                                 >
                                    <Pencil className="lucide" />
                                    {/* <FcAcceptDatabase style={estilo} /> */}
                                 </Link>
                                 &nbsp;&nbsp;
                                 <SquareX
                                    className="lucideIconDel"
                                    onClick={() =>
                                       handleRemove(insu.id_primary)
                                    }
                                 />
                              </td>
                           </tr>
                        );
                     })}
               </tbody>
            </table>
         </div>
      </>
   );
};

export default Abmgiftcardpier;
